/** Maps app page ids to canonical URL paths (no trailing slash except home). */
export const PAGE_PATH_BY_ID = {
  home: '/',
  bhagyank: '/bhagyank',
  'birth-chart': '/birth-chart',
  'lo-shu': '/lo-shu',
  'time-cycles': '/time-cycles',
  pinnacles: '/pinnacles',
  'personal-year': '/personal-year',
  'name-analysis': '/name-analysis',
  mahadasha: '/mahadasha',
  kua: '/kua-number',
  'lucky-colours': '/lucky-colours',
  'ist-devta': '/ishta-devta',
  mobile: '/mobile-numerology',
  'friendly-numbers': '/friendly-numbers',
  'unfriendly-numbers': '/unfriendly-numbers',
  'address-vibration': '/address-vibration',
  'number-vibration': '/number-vibration',
  jyotisha: '/jyotisha',
  'jyotish-marga': '/jyotish-marga',
  phaladeepika: '/phaladeepika',
  sadhana: '/sadhana',
  profile: '/profile',
  settings: '/settings',
  admin: '/admin',
  'admin-security-audit': '/admin/security-audit',
  'admin-prd': '/admin/prd',
  help: '/help',
  'ask-guru': '/ask-guru',
};

/** Numerology / Ankotish section (excludes Jyotisha topic marquee). */
export const ANKOTISH_PAGE_IDS = new Set([
  'bhagyank',
  'birth-chart',
  'lo-shu',
  'time-cycles',
  'pinnacles',
  'personal-year',
  'name-analysis',
  'mahadasha',
  'kua',
  'lucky-colours',
  'ist-devta',
  'mobile',
  'friendly-numbers',
  'unfriendly-numbers',
  'address-vibration',
  'number-vibration',
]);

/**
 * @param {string} pageId
 * @returns {boolean}
 */
export function isAnkotishPage(pageId) {
  return ANKOTISH_PAGE_IDS.has(pageId);
}

/** Sadhana section (excludes Jyotisha topic marquee). */
export const SADHANA_PAGE_IDS = new Set(['sadhana']);

/**
 * @param {string} pageId
 * @returns {boolean}
 */
export function isSadhanaPage(pageId) {
  return SADHANA_PAGE_IDS.has(pageId);
}

/** Pages that show the Jyotisha topic marquee above the mobile tab bar. */
export const MARQUEE_PAGE_IDS = new Set(['home', 'jyotisha']);

/**
 * @param {string} pageId
 * @returns {boolean}
 */
export function shouldShowJyotishaTopicMarquee(pageId) {
  return MARQUEE_PAGE_IDS.has(pageId);
}

/** @type {Record<string, string>} */
export const PAGE_ID_BY_PATH = Object.fromEntries(
  Object.entries(PAGE_PATH_BY_ID).map(([id, path]) => [path, id]),
);

/**
 * @param {string} pageId
 * @returns {string}
 */
export function getPathForPageId(pageId) {
  return PAGE_PATH_BY_ID[pageId] ?? '/';
}

/**
 * Resolve page id from pathname (ignores query/hash).
 * @param {string} pathname
 * @returns {string | null}
 */
export function getPageIdFromPathname(pathname) {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return PAGE_ID_BY_PATH[normalized] ?? null;
}

/** Public pages included in XML sitemap (excludes noindex pages). */
export const SITEMAP_PAGE_IDS = Object.keys(PAGE_PATH_BY_ID).filter(
  (id) =>
    id !== 'profile' &&
    id !== 'settings' &&
    id !== 'admin' &&
    id !== 'admin-security-audit' &&
    id !== 'admin-prd',
);
